import { create } from "zustand";
import russianLocalization from "../Services/dc_russian_localization.json";
import englishLocalization from "../Services/dc_english_localization.json";


const messageShowTime = 2000;

const useApplicationSettings = create((set) => ({
  isFirstStart: false,
  setIsFirstStart: (value) =>
    set((state) => {
      return {
        isFirstStart: value,
      };
    }),

  leaderBoardRewardType: "farmed",
  setLeaderBoardRewardType: (value) =>
    set((state) => {
      return {
        leaderBoardRewardType: value,
      };
    }),

  pagesMarker: [false, false, false, false, false],
  setPagesMarker: (position, value) =>
    set((state) => {
      const newPagesMarker = [...state.pagesMarker];
      newPagesMarker[position] = value;
      return {
        pagesMarker: newPagesMarker,
      };
    }),

  contentToLoad: 0,
  setContentToLoad: (value) =>
    set((state) => {
      return {
        contentToLoad: state.contentToLoad + 1,
      };
    }),

  loadedContent: 0,
  setLoadedContent: (value) =>
    set((state) => {
      return {
        loadedContent: state.loadedContent + 1,
      };
    }),

  showMenubar: false,
  setShowMenubar: (value) =>
    set((state) => {
      return {
        showMenubar: value,
      };
    }),

  menubarTrigger: { triggerName: "" },
  setMenubarTrigger: (value) =>
    set((state) => {
      if (state.menubarTrigger.triggerName !== value.triggerName) {
     
        return {
          menubarTrigger: value,
        };
      }
      return state;
    }),

  stopCoin: false,
  setStopCoin: (value) =>
    set((state) => {
      return {
        stopCoin: value,
      };
    }),

  lottery_date_start: 0,
  setLottery_date_start: (value) =>
    set((state) => {
      return {
        lottery_date_start: value,
      };
    }),

  lottery_date_end: 0,
  setLottery_date_end: (value) =>
    set((state) => {
      return {
        lottery_date_end: value,
      };
    }),

  server_time: 0,
  setServer_time: (value) =>
    set((state) => {
      return {
        server_time: value,
      };
    }),

  lotteryTimeLeft: 0,
  setLotteryTimeLeft: (value) =>
    set((state) => {
      return {
        lotteryTimeLeft: value,
      };
    }),

  // delete this and off in Application
  showDialogMenu: true,
  setShowDialogMenu: (value) =>
    set((state) => {
      state.dialogMenuContent.pop();
      return {
        showDialogMenu: value,
      };
    }),

  dialogMenuContent: [],
  setDialogMenuContent: (value, name, props = {}, needCloseButton = true) =>
    set((state) => {
      let newDialogMenuContent = [...state.dialogMenuContent];
      if (
        newDialogMenuContent.findIndex((element) => element.name == name) < 0
      ) {
        
        newDialogMenuContent.push({
          props: props,
          value: value,
          name: name,
          hide: newDialogMenuContent.length > 0 ? true : false,
          needCloseButton: needCloseButton,
        });
    
      }
      return {
        dialogMenuContent: newDialogMenuContent,
      };
    }),

  popDialogMenuContent: (name) =>
    set((state) => {
      let newDialogMenuContent = state.dialogMenuContent.filter(
        (element) => element.name != name
      );
      if (newDialogMenuContent.length > 0) {
        newDialogMenuContent[0].hide = false;
      }

      return { dialogMenuContent: newDialogMenuContent };
    }),

  messageInformation: { icon: null, information: "nothing", background: "red" },
  showMessage: false,
  messageIntervalObject: null,
  localization: russianLocalization,
  setLocalization: (localization) =>
    set((state) => {
      switch (localization) {
        case "rus":
          return { localization: russianLocalization };
          break;
        case "eng":
          return { localization: englishLocalization };
          break;
      }
    }),
}))

export default useApplicationSettings;
